(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onLogoTransitionEnd = this.onLogoTransitionEnd.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.isAnimatingHeaderHeight = false;
      this.headerHeightAnimationTimeout = null;

      this.setHeaderHeight();

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if ('ResizeObserver' in window && this.header) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.isAnimatingHeaderHeight) return;
          this.setHeaderHeight();
        });
        this.resizeObserver.observe(this.header);
      }

      window.addEventListener('load', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.lastStableScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.onOverlayOpen = this.onHeaderOverlayOpening.bind(this);
      this.onCartDrawerClose = () => {
        window.requestAnimationFrame(() => this.restoreHeaderAfterOverlay());
      };
      document.addEventListener('cart-drawer:open', this.onOverlayOpen);
      document.addEventListener('cart-drawer:close', this.onCartDrawerClose);

      this.onHeaderPointerDown = (event) => {
        if (
          !event.target.closest(
            '.header__icon--cart, localization-form, header-drawer .header__icon--menu'
          )
        ) {
          return;
        }
        this.onHeaderOverlayOpening();
      };
      this.addEventListener('pointerdown', this.onHeaderPointerDown, true);

      this.logoWrapper = this.header?.querySelector('.header__heading-logo-wrapper');
      this.mainHeadingLink = this.querySelector('.header__heading-link:not(.header__heading-link--compact)');
      this.logoWrapper?.addEventListener('transitionend', this.onLogoTransitionEnd);
      this.mainHeadingLink?.addEventListener('transitionend', this.onLogoTransitionEnd);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.updateHeaderBoundsForTransparent();
    }

    updateHeaderBoundsForTransparent() {
      if (!this.header || !this.classList.contains('header-transparent')) return;

      const announcementBar = this.header.querySelector('.announcement-bar-section');
      const headerElement = this.querySelector('.header');
      const announcementHeight = announcementBar?.offsetHeight || 0;
      const headerHeight = headerElement?.offsetHeight || 0;
      const stackBottom = announcementHeight + headerHeight;

      if (stackBottom <= 0) return;

      this.headerBounds = {
        top: this.headerBounds?.top ?? 0,
        left: this.headerBounds?.left ?? 0,
        right: this.headerBounds?.right ?? 0,
        width: this.headerBounds?.width ?? 0,
        x: this.headerBounds?.x ?? 0,
        y: this.headerBounds?.y ?? 0,
        height: stackBottom,
        bottom: stackBottom,
      };
    }

    getHeaderScrollThreshold() {
      this.updateHeaderBoundsForTransparent();
      if (this.headerBounds?.bottom > 0) return this.headerBounds.bottom;
      return this.header?.offsetHeight || 0;
    }

    getWindowScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    usesCompactHeaderOnScroll() {
      return Boolean(this.classList.contains('header-wrapper--compact-on-scroll'));
    }

    isHeaderOverlayOpen() {
      if (this.header?.classList.contains('menu-open')) return true;
      if (document.querySelector('cart-drawer.active')) return true;
      if (this.querySelector('details-modal details[open]')) return true;
      if (this.querySelector('localization-form .disclosure__button[aria-expanded="true"]')) return true;
      return false;
    }

    shouldPauseScrollCollapse() {
      if (this.isHeaderOverlayOpen()) return true;
      if (this.preventHide) return true;
      if (this.suppressScrollHandlingUntil && performance.now() < this.suppressScrollHandlingUntil) return true;
      return false;
    }

    applyScrolledHeaderState(scrollTop) {
      const scrollThreshold = this.getHeaderScrollThreshold();
      const isPastHeader = scrollTop > scrollThreshold;

      this.header.classList.toggle('scrolled-past-header', isPastHeader);

      if (this.headerIsAlwaysSticky) return;

      if (isPastHeader) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
      } else {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    onHeaderOverlayOpening() {
      this.lastStableScrollTop = Math.max(this.lastStableScrollTop, this.currentScrollTop, this.getWindowScrollTop());
      this.suppressScrollHandlingUntil = performance.now() + 800;
      if (!this.header) return;
      this.applyScrolledHeaderState(this.lastStableScrollTop);
      this.setHeaderHeight();
    }

    restoreHeaderAfterOverlay() {
      if (!this.header) return;

      window.requestAnimationFrame(() => {
        const liveScrollTop = this.getWindowScrollTop();
        const scrollTop =
          liveScrollTop > 20 ? liveScrollTop : Math.max(liveScrollTop, this.lastStableScrollTop || 0);

        this.currentScrollTop = scrollTop;
        this.lastStableScrollTop = scrollTop;
        this.applyScrolledHeaderState(scrollTop);
        this.setHeaderHeight();
      });
    }

    onLogoTransitionEnd(event) {
      const property = event.propertyName;
      if (property !== 'width' && property !== 'max-height' && property !== 'opacity' && property !== 'padding-bottom' && property !== 'padding-top') {
        return;
      }
      this.isAnimatingHeaderHeight = false;
      window.clearTimeout(this.headerHeightAnimationTimeout);
      this.setHeaderHeight();
    }

    syncHeaderHeightWithLogo(hadScrolledPast) {
      if (this.mobileMediaQuery?.matches) {
        this.setHeaderHeight();
        return;
      }

      const isCompactOnScroll = this.usesCompactHeaderOnScroll();
      const isReduceLogoSize = this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      if (!isCompactOnScroll && (!isReduceLogoSize || !this.logoWrapper)) {
        this.setHeaderHeight();
        return;
      }

      const isScrolledPast = this.header.classList.contains('scrolled-past-header');
      if (isScrolledPast === hadScrolledPast) {
        this.setHeaderHeight();
        return;
      }

      if (this.logoWrapper) {
        this.logoWrapper.style.transition = 'none';
      }

      this.header.classList.add('header-height-no-transition');
      document.documentElement.classList.add('header-height-no-transition');

      let startHeight;
      let endHeight;

      if (isCompactOnScroll) {
        const { collapsedHeight, expandedHeight } = this.measureCompactHeaderHeights();
        startHeight = isScrolledPast ? expandedHeight : collapsedHeight;
        endHeight = isScrolledPast ? collapsedHeight : expandedHeight;

        if (isScrolledPast) {
          this.header.classList.remove('scrolled-past-header');
        } else {
          this.header.classList.add('scrolled-past-header');
        }
      } else if (isScrolledPast) {
        endHeight = this.header.offsetHeight;
        this.header.classList.remove('scrolled-past-header');
        this.header.offsetHeight;
        startHeight = this.header.offsetHeight;
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.add('scrolled-past-header');
        this.header.offsetHeight;
        startHeight = this.header.offsetHeight;
        this.header.classList.remove('scrolled-past-header');
        this.header.offsetHeight;
        endHeight = this.header.offsetHeight;
      }

      document.documentElement.style.setProperty('--header-height', `${startHeight}px`);
      this.header.offsetHeight;

      this.header.classList.remove('header-height-no-transition');
      document.documentElement.classList.remove('header-height-no-transition');

      if (this.logoWrapper) {
        this.logoWrapper.style.transition = '';
      }

      this.isAnimatingHeaderHeight = true;
      this.header.classList.add('header-compact-animating');
      window.clearTimeout(this.headerHeightAnimationTimeout);
      window.requestAnimationFrame(() => {
        if (isCompactOnScroll) {
          if (isScrolledPast) {
            this.header.classList.add('scrolled-past-header');
          } else {
            this.header.classList.remove('scrolled-past-header');
          }

          const headingLink = this.querySelector(
            '.header__heading-link:not(.header__heading-link--compact)'
          );
          const compactLink = this.querySelector('.header__heading-link--compact');
          const targetScrolledPast = this.header.classList.contains('scrolled-past-header');
          if (targetScrolledPast) {
            headingLink?.setAttribute('inert', '');
            compactLink?.removeAttribute('aria-hidden');
            compactLink?.removeAttribute('tabindex');
          } else {
            headingLink?.removeAttribute('inert');
            compactLink?.setAttribute('aria-hidden', 'true');
            compactLink?.setAttribute('tabindex', '-1');
          }
        }
        document.documentElement.style.setProperty('--header-height', `${endHeight}px`);
      });
      this.headerHeightAnimationTimeout = window.setTimeout(() => {
        this.isAnimatingHeaderHeight = false;
        this.header.classList.remove('header-compact-animating');
        this.setHeaderHeight();
      }, 450);
    }

    measureCompactHeaderHeights() {
      if (!this.header) return { collapsedHeight: 0, expandedHeight: 0 };
      const hadScrolledPast = this.header.classList.contains('scrolled-past-header');

      this.header.classList.add('header-height-no-transition');
      document.documentElement.classList.add('header-height-no-transition');

      this.header.classList.add('scrolled-past-header');
      const collapsedHeight = this.header.offsetHeight;
      this.header.classList.remove('scrolled-past-header');
      const expandedHeight = this.header.offsetHeight;

      if (hadScrolledPast) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      this.header.classList.remove('header-height-no-transition');
      document.documentElement.classList.remove('header-height-no-transition');

      return { collapsedHeight, expandedHeight };
    }

    disconnectedCallback() {
      this.mobileMediaQuery?.removeEventListener('change', this.setHeaderHeight);
      this.resizeObserver?.disconnect();
      this.logoWrapper?.removeEventListener('transitionend', this.onLogoTransitionEnd);
      this.mainHeadingLink?.removeEventListener('transitionend', this.onLogoTransitionEnd);
      window.clearTimeout(this.headerHeightAnimationTimeout);
      window.removeEventListener('load', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('cart-drawer:open', this.onOverlayOpen);
      document.removeEventListener('cart-drawer:close', this.onCartDrawerClose);
      this.removeEventListener('pointerdown', this.onHeaderPointerDown, true);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        this.updateHeaderBoundsForTransparent();
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = this.getWindowScrollTop();
      const hadScrolledPast = this.header.classList.contains('scrolled-past-header');
      const scrollThreshold = this.getHeaderScrollThreshold();
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.shouldPauseScrollCollapse()) return;

      if (scrollDelta > 1 && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) {
          this.reveal();
        } else {
          this.hide();
        }
      } else if (scrollDelta < -1 && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= scrollThreshold) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      if (this.header.classList.contains('scrolled-past-header') !== hadScrolledPast) {
        this.syncHeaderHeightWithLogo(hadScrolledPast);
      }

      this.currentScrollTop = scrollTop;
      this.lastStableScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      window.requestAnimationFrame(() => {
        this.setHeaderHeight();
        window.requestAnimationFrame(() => this.setHeaderHeight());
      });
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      window.requestAnimationFrame(() => {
        this.setHeaderHeight();
        window.requestAnimationFrame(() => this.setHeaderHeight());
      });
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal || typeof this.searchModal.close !== 'function') return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look-section"] && !Shopify.designMode) return;
  try {
    
  class ShopTheLookPopup extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('.shop-the-look__popup-close');
      
      const banner = this.closest('.hero-banner');
      if (banner) {
        this.mediaTriggers = banner.querySelectorAll('.shop-the-look__popup-trigger-media');
        this.buttonTriggers = banner.querySelectorAll('.shop-the-look__popup-trigger-button');
        
        // Save original text for mobile toggle
        this.buttonTriggers.forEach(trigger => {
          const span = trigger.querySelector('span');
          if (span) {
            trigger.setAttribute('data-original-text', span.textContent);
          }
        });

        this.mediaTriggers.forEach(trigger => {
          trigger.addEventListener('click', this.handleMediaClick.bind(this));
        });
        this.buttonTriggers.forEach(trigger => {
          trigger.addEventListener('click', this.handleButtonClick.bind(this));
        });
      }

      if(this.closeBtn) {
        this.closeBtn.addEventListener('click', this.closePopup.bind(this));
      }
    }

    isMobile() {
      return window.innerWidth <= 768;
    }
    
    handleMediaClick(e) {
      e.preventDefault();
      this.openPopup();
    }

    handleButtonClick(e) {
      e.preventDefault();
      if (this.isMobile() && this.classList.contains('is-active')) {
        this.closePopup();
      } else {
        this.openPopup();
      }
    }

    openPopup() {
      this.classList.add('is-active');
      if (this.isMobile()) {
        this.buttonTriggers.forEach(trigger => {
          const span = trigger.querySelector('span');
          if (span) {
            span.textContent = 'Ocultar Look'; 
          }
        });
      }
    }
    
    closePopup() {
      this.classList.remove('is-active');
      this.buttonTriggers.forEach(trigger => {
        const span = trigger.querySelector('span');
        if (span && trigger.hasAttribute('data-original-text')) {
          span.textContent = trigger.getAttribute('data-original-text');
        }
      });
    }
  }
  
  if (!customElements.get('shop-the-look-popup')) {
    customElements.define('shop-the-look-popup', ShopTheLookPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
